import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "unpublished-theme-item",
  "data-theme": "unpublished"
}
const _hoisted_2 = { class: "unpublished-theme-item__wrapper-header" }
const _hoisted_3 = { class: "unpublished-theme-item__wrapper-image" }
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "unpublished-theme-item__blur-image" }, null, -1)
const _hoisted_6 = { class: "unpublished-theme-item__theme-name" }
const _hoisted_7 = { class: "unpublished-theme-item__content" }
const _hoisted_8 = { class: "unpublished-theme-item__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThemeTags = _resolveComponent("ThemeTags")!
  const _component_PreviewButton = _resolveComponent("PreviewButton")!
  const _component_ButtonOptions = _resolveComponent("ButtonOptions")!
  const _component_ActionsButton = _resolveComponent("ActionsButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ThemeTags, {
          updated: _ctx.updated,
          paid: _ctx.paid,
          payment: _ctx.payment
        }, null, 8, ["updated", "paid", "payment"]),
        _createElementVNode("img", {
          alt: _ctx.$t('components.unpublished-list-themes.theme-item.image.alt'),
          src: _ctx.thumb,
          class: "unpublished-theme-item__image",
          loading: "lazy"
        }, null, 8, _hoisted_4),
        _hoisted_5,
        _createVNode(_component_PreviewButton, {
          "test-id": "btn-theme-preview",
          class: _normalizeClass(["unpublished-theme-item__button-preview", 
            _ctx.hasTagPaymentInProcess
              ? 'unpublished-theme-item__button-preview--re-centered'
              : 'unpublished-theme-item__button-preview--centralized'
          ]),
          label: 
            _ctx.$t('components.unpublished-list-themes.theme-item.button.preview')
          ,
          onThemePreview: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('theme-preview')))
        }, null, 8, ["class", "label"])
      ]),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.name), 1)
    ]),
    _createElementVNode("main", _hoisted_7, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.unpublished-list-themes.theme-item.code')) + ": " + _toDisplayString(_ctx.id), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.unpublished-list-themes.theme-item.last-update')) + ": " + _toDisplayString(_ctx.updatedAt), 1)
    ]),
    _createElementVNode("footer", _hoisted_8, [
      (_ctx.paid || _ctx.payment.status != _ctx.PaymentStatus.INVOICE_CANCELED)
        ? (_openBlock(), _createBlock(_component_ButtonOptions, {
            key: 0,
            label: 
          _ctx.$t(
            'components.unpublished-list-themes.theme-item.button.options.more-options'
          )
        ,
            paid: _ctx.paid,
            updated: _ctx.updated,
            onThemeEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('theme-edit'))),
            onThemeHtmlEdit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('theme-html-edit'))),
            onThemeRename: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('theme-rename'))),
            onThemeChangeLog: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('theme-change-log'))),
            onThemeDuplicate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('theme-duplicate'))),
            onThemeUpdatedVersion: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('theme-updated-version'))),
            onThemeDelete: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('theme-delete')))
          }, null, 8, ["label", "paid", "updated"]))
        : _createCommentVNode("", true),
      (_ctx.paid)
        ? (_openBlock(), _createBlock(_component_ActionsButton, {
            key: 1,
            "test-id": "btn-theme-publish",
            type: "publish",
            label: 
          _ctx.$t('components.unpublished-list-themes.theme-item.button.publish')
        ,
            onThemePublish: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('theme-publish')))
          }, null, 8, ["label"]))
        : (
          _ctx.payment.status != _ctx.PaymentStatus.THEME_FOR_SALE &&
          _ctx.payment.status != _ctx.PaymentStatus.INVOICE_CANCELED
        )
          ? (_openBlock(), _createBlock(_component_ActionsButton, {
              key: 2,
              "test-id": "btn-theme-change-payment",
              type: "change-payment",
              label: 
          _ctx.$t(
            'components.unpublished-list-themes.theme-item.button.change-payment'
          )
        ,
              onThemeChangePayment: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('theme-change-payment')))
            }, null, 8, ["label"]))
          : (_ctx.payment.status == _ctx.PaymentStatus.INVOICE_CANCELED)
            ? (_openBlock(), _createBlock(_component_ActionsButton, {
                key: 3,
                "test-id": "btn-theme-delete",
                type: "delete",
                label: 
          _ctx.$t('components.unpublished-list-themes.theme-item.button.delete')
        ,
                onThemeDelete: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('theme-delete')))
              }, null, 8, ["label"]))
            : (_openBlock(), _createBlock(_component_ActionsButton, {
                key: 4,
                "test-id": "btn-theme-buy",
                type: "buy",
                label: _ctx.$t('components.unpublished-list-themes.theme-item.button.buy'),
                onThemeBuy: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('theme-buy')))
              }, null, 8, ["label"]))
    ])
  ]))
}